import Grid from "@mui/material/Grid";
import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import MenuItem from "@mui/material/MenuItem";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import EmailCheck from "../../../EmailCheck/EmailCheck";
import ButtonLoading from "../../../Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "../../Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React from "react";
import { useForm } from "../../../../provider/Form/FormProvider";
import { emailDefault, isPhoneNumberDefault, minStringLength, requiredValidator } from "../../../../services/validationRules";

type FamilyLawCheckinFormProps = {
  isLoading: boolean;
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  additionalFormFields?: React.ReactNode;
};

export default function FamilyLawCheckinForm({ isLoading, emailErrorText, setEmailErrorText, additionalFormFields }: FamilyLawCheckinFormProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "baseline",
          justifyContent: "center"
        }}>
        <Grid
          sx={{ paddingRight: { md: "3rem" } }}
          size={{
            xs: 12,
            md: 4
          }}>
          <ValidatorSelectField label="Anrede" name={`gender`} validators={[requiredValidator("Bitte geben Sie Ihre Anrede an.")]} autoComplete="sex">
            <MenuItem value={"female"}>Frau</MenuItem>
            <MenuItem value={"male"}>Herr</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          sx={{ paddingRight: { sm: "3rem" } }}
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <ValidatorTextField
            name={`givenName`}
            label="Vorname"
            autoComplete="given-name"
            validators={[
              requiredValidator("Bitte geben Sie den Vornamen an"),
              { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
            ]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <ValidatorTextField
            name={`familyName`}
            label="Nachname"
            autoComplete="family-name"
            validators={[
              requiredValidator("Bitte geben Sie den Nachnamen an"),
              { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
            ]}
          />
        </Grid>

        {additionalFormFields && (
          <Grid
            size={{
              xs: 12,
              md: 12
            }}>
            {additionalFormFields}
          </Grid>
        )}

        <Grid
          sx={{ paddingRight: { sm: "3rem" } }}
          size={{
            xs: 12,
            sm: 6
          }}>
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
            redirectProps={null}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          <ValidatorTextField
            name="telephone"
            label="Ihre Telefonnummer"
            autoComplete="tel"
            validators={[requiredValidator("Bitte geben Sie Ihre Telefonnummer an"), ...isPhoneNumberDefault]}
          />
        </Grid>
        <Grid
          sx={{ paddingTop: "1rem" }}
          size={{
            xs: 12,
            sm: 6
          }}>
          <ButtonLoading variant="contained" color="primary" sx={{ marginTop: { md: "25px" } }} type="submit" fullWidth isLoading={isLoading}>
            jetzt kostenlos starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
